/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var spine_options_pb = require('../../../../spine/options_pb.js');
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
var spine_core_event_pb = require('../../../../spine/core/event_pb.js');
var spine_core_command_pb = require('../../../../spine/core/command_pb.js');
var spine_system_server_entity_history_pb = require('../../../../spine/system/server/entity_history_pb.js');
goog.exportSymbol('proto.spine.system.server.CannotDispatchCommandTwice', null, global);
goog.exportSymbol('proto.spine.system.server.CannotDispatchEventTwice', null, global);

/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.system.server.CannotDispatchEventTwice = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.system.server.CannotDispatchEventTwice, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.system.server.CannotDispatchEventTwice.displayName = 'proto.spine.system.server.CannotDispatchEventTwice';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.system.server.CannotDispatchEventTwice.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.system.server.CannotDispatchEventTwice.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.system.server.CannotDispatchEventTwice} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.CannotDispatchEventTwice.toObject = function(includeInstance, msg) {
  var f, obj = {
    receiver: (f = msg.getReceiver()) && spine_system_server_entity_history_pb.EntityHistoryId.toObject(includeInstance, f),
    payload: (f = msg.getPayload()) && spine_core_event_pb.Event.toObject(includeInstance, f),
    whenDispatched: (f = msg.getWhenDispatched()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.system.server.CannotDispatchEventTwice}
 */
proto.spine.system.server.CannotDispatchEventTwice.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.system.server.CannotDispatchEventTwice;
  return proto.spine.system.server.CannotDispatchEventTwice.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.system.server.CannotDispatchEventTwice} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.system.server.CannotDispatchEventTwice}
 */
proto.spine.system.server.CannotDispatchEventTwice.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new spine_system_server_entity_history_pb.EntityHistoryId;
      reader.readMessage(value,spine_system_server_entity_history_pb.EntityHistoryId.deserializeBinaryFromReader);
      msg.setReceiver(value);
      break;
    case 2:
      var value = new spine_core_event_pb.Event;
      reader.readMessage(value,spine_core_event_pb.Event.deserializeBinaryFromReader);
      msg.setPayload(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setWhenDispatched(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.system.server.CannotDispatchEventTwice.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.system.server.CannotDispatchEventTwice.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.system.server.CannotDispatchEventTwice} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.CannotDispatchEventTwice.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReceiver();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      spine_system_server_entity_history_pb.EntityHistoryId.serializeBinaryToWriter
    );
  }
  f = message.getPayload();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      spine_core_event_pb.Event.serializeBinaryToWriter
    );
  }
  f = message.getWhenDispatched();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional EntityHistoryId receiver = 1;
 * @return {?proto.spine.system.server.EntityHistoryId}
 */
proto.spine.system.server.CannotDispatchEventTwice.prototype.getReceiver = function() {
  return /** @type{?proto.spine.system.server.EntityHistoryId} */ (
    jspb.Message.getWrapperField(this, spine_system_server_entity_history_pb.EntityHistoryId, 1));
};


/** @param {?proto.spine.system.server.EntityHistoryId|undefined} value */
proto.spine.system.server.CannotDispatchEventTwice.prototype.setReceiver = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.spine.system.server.CannotDispatchEventTwice.prototype.clearReceiver = function() {
  this.setReceiver(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.CannotDispatchEventTwice.prototype.hasReceiver = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional spine.core.Event payload = 2;
 * @return {?proto.spine.core.Event}
 */
proto.spine.system.server.CannotDispatchEventTwice.prototype.getPayload = function() {
  return /** @type{?proto.spine.core.Event} */ (
    jspb.Message.getWrapperField(this, spine_core_event_pb.Event, 2));
};


/** @param {?proto.spine.core.Event|undefined} value */
proto.spine.system.server.CannotDispatchEventTwice.prototype.setPayload = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.spine.system.server.CannotDispatchEventTwice.prototype.clearPayload = function() {
  this.setPayload(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.CannotDispatchEventTwice.prototype.hasPayload = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp when_dispatched = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.spine.system.server.CannotDispatchEventTwice.prototype.getWhenDispatched = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/** @param {?proto.google.protobuf.Timestamp|undefined} value */
proto.spine.system.server.CannotDispatchEventTwice.prototype.setWhenDispatched = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


proto.spine.system.server.CannotDispatchEventTwice.prototype.clearWhenDispatched = function() {
  this.setWhenDispatched(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.CannotDispatchEventTwice.prototype.hasWhenDispatched = function() {
  return jspb.Message.getField(this, 3) != null;
};



/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.spine.system.server.CannotDispatchCommandTwice = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.spine.system.server.CannotDispatchCommandTwice, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  proto.spine.system.server.CannotDispatchCommandTwice.displayName = 'proto.spine.system.server.CannotDispatchCommandTwice';
}


if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto suitable for use in Soy templates.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     com.google.apps.jspb.JsClassTemplate.JS_RESERVED_WORDS.
 * @param {boolean=} opt_includeInstance Whether to include the JSPB instance
 *     for transitional soy proto support: http://goto/soy-param-migration
 * @return {!Object}
 */
proto.spine.system.server.CannotDispatchCommandTwice.prototype.toObject = function(opt_includeInstance) {
  return proto.spine.system.server.CannotDispatchCommandTwice.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Whether to include the JSPB
 *     instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.spine.system.server.CannotDispatchCommandTwice} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.CannotDispatchCommandTwice.toObject = function(includeInstance, msg) {
  var f, obj = {
    receiver: (f = msg.getReceiver()) && spine_system_server_entity_history_pb.EntityHistoryId.toObject(includeInstance, f),
    payload: (f = msg.getPayload()) && spine_core_command_pb.Command.toObject(includeInstance, f),
    whenDispatched: (f = msg.getWhenDispatched()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.spine.system.server.CannotDispatchCommandTwice}
 */
proto.spine.system.server.CannotDispatchCommandTwice.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.spine.system.server.CannotDispatchCommandTwice;
  return proto.spine.system.server.CannotDispatchCommandTwice.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.spine.system.server.CannotDispatchCommandTwice} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.spine.system.server.CannotDispatchCommandTwice}
 */
proto.spine.system.server.CannotDispatchCommandTwice.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new spine_system_server_entity_history_pb.EntityHistoryId;
      reader.readMessage(value,spine_system_server_entity_history_pb.EntityHistoryId.deserializeBinaryFromReader);
      msg.setReceiver(value);
      break;
    case 2:
      var value = new spine_core_command_pb.Command;
      reader.readMessage(value,spine_core_command_pb.Command.deserializeBinaryFromReader);
      msg.setPayload(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setWhenDispatched(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.spine.system.server.CannotDispatchCommandTwice.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.spine.system.server.CannotDispatchCommandTwice.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.spine.system.server.CannotDispatchCommandTwice} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.spine.system.server.CannotDispatchCommandTwice.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getReceiver();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      spine_system_server_entity_history_pb.EntityHistoryId.serializeBinaryToWriter
    );
  }
  f = message.getPayload();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      spine_core_command_pb.Command.serializeBinaryToWriter
    );
  }
  f = message.getWhenDispatched();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional EntityHistoryId receiver = 1;
 * @return {?proto.spine.system.server.EntityHistoryId}
 */
proto.spine.system.server.CannotDispatchCommandTwice.prototype.getReceiver = function() {
  return /** @type{?proto.spine.system.server.EntityHistoryId} */ (
    jspb.Message.getWrapperField(this, spine_system_server_entity_history_pb.EntityHistoryId, 1));
};


/** @param {?proto.spine.system.server.EntityHistoryId|undefined} value */
proto.spine.system.server.CannotDispatchCommandTwice.prototype.setReceiver = function(value) {
  jspb.Message.setWrapperField(this, 1, value);
};


proto.spine.system.server.CannotDispatchCommandTwice.prototype.clearReceiver = function() {
  this.setReceiver(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.CannotDispatchCommandTwice.prototype.hasReceiver = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional spine.core.Command payload = 2;
 * @return {?proto.spine.core.Command}
 */
proto.spine.system.server.CannotDispatchCommandTwice.prototype.getPayload = function() {
  return /** @type{?proto.spine.core.Command} */ (
    jspb.Message.getWrapperField(this, spine_core_command_pb.Command, 2));
};


/** @param {?proto.spine.core.Command|undefined} value */
proto.spine.system.server.CannotDispatchCommandTwice.prototype.setPayload = function(value) {
  jspb.Message.setWrapperField(this, 2, value);
};


proto.spine.system.server.CannotDispatchCommandTwice.prototype.clearPayload = function() {
  this.setPayload(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.CannotDispatchCommandTwice.prototype.hasPayload = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp when_dispatched = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.spine.system.server.CannotDispatchCommandTwice.prototype.getWhenDispatched = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/** @param {?proto.google.protobuf.Timestamp|undefined} value */
proto.spine.system.server.CannotDispatchCommandTwice.prototype.setWhenDispatched = function(value) {
  jspb.Message.setWrapperField(this, 3, value);
};


proto.spine.system.server.CannotDispatchCommandTwice.prototype.clearWhenDispatched = function() {
  this.setWhenDispatched(undefined);
};


/**
 * Returns whether this field is set.
 * @return {!boolean}
 */
proto.spine.system.server.CannotDispatchCommandTwice.prototype.hasWhenDispatched = function() {
  return jspb.Message.getField(this, 3) != null;
};


goog.object.extend(exports, proto.spine.system.server);

// The code for parsing the Protobuf messages of this file from the JSON data.

let known_type_parsers = require('../../../../known_type_parsers.js');

proto.spine.system.server.CannotDispatchEventTwice.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.system.server.CannotDispatchEventTwice.fromObject(jsObject);
};

proto.spine.system.server.CannotDispatchEventTwice.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.system.server.CannotDispatchEventTwice();
  
  if (obj.receiver !== undefined) {
    if (obj.receiver === null) {
      msg.setReceiver(null);
    } else {
      let value = proto.spine.system.server.EntityHistoryId.fromObject(obj.receiver);
      msg.setReceiver(value);
    }
  }
  
  if (obj.payload !== undefined) {
    if (obj.payload === null) {
      msg.setPayload(null);
    } else {
      let value = proto.spine.core.Event.fromObject(obj.payload);
      msg.setPayload(value);
    }
  }
  
  if (obj.whenDispatched !== undefined) {
    if (obj.whenDispatched === null) {
      msg.setWhenDispatched(null);
    } else {
      let parser = known_type_parsers.parsers.get('type.googleapis.com/google.protobuf.Timestamp');
      let value = parser.parse(obj.whenDispatched);
      msg.setWhenDispatched(value);
    }
  }
  return msg;
};

proto.spine.system.server.CannotDispatchCommandTwice.fromJson = function(json) {
  let jsObject = JSON.parse(json);
  return proto.spine.system.server.CannotDispatchCommandTwice.fromObject(jsObject);
};

proto.spine.system.server.CannotDispatchCommandTwice.fromObject = function(obj) {
  if (obj === null) {
    return null;
  }
  
  let msg = new proto.spine.system.server.CannotDispatchCommandTwice();
  
  if (obj.receiver !== undefined) {
    if (obj.receiver === null) {
      msg.setReceiver(null);
    } else {
      let value = proto.spine.system.server.EntityHistoryId.fromObject(obj.receiver);
      msg.setReceiver(value);
    }
  }
  
  if (obj.payload !== undefined) {
    if (obj.payload === null) {
      msg.setPayload(null);
    } else {
      let value = proto.spine.core.Command.fromObject(obj.payload);
      msg.setPayload(value);
    }
  }
  
  if (obj.whenDispatched !== undefined) {
    if (obj.whenDispatched === null) {
      msg.setWhenDispatched(null);
    } else {
      let parser = known_type_parsers.parsers.get('type.googleapis.com/google.protobuf.Timestamp');
      let value = parser.parse(obj.whenDispatched);
      msg.setWhenDispatched(value);
    }
  }
  return msg;
};
